module.exports = fox._r("images/promo/tutorial/04.png", __webpack_public_path__ + "_/common/images/promo/tutorial/04.png");


//////////////////
// WEBPACK FOOTER
// ../common/images/promo/tutorial/04.png
// module id = 653
// module chunks = 2